import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {PsychometricParameter} from "../../gen/api";
import DeleteButton from "../DeleteButton/DeleteButton";
import MarkdownPreviewWithEditDialog from "../Markdown/MarkdownPreviewWithEditDialog";
import PsychometricParameterTable from "./PsychometricParameterTable";
import {IconButton} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

type Props = {
  type: string
  psychometricParameters: PsychometricParameter[]
  setPsychometricParameters: React.Dispatch<PsychometricParameter[]>
}

export default function EditPsychometricParameterTable({
                                                         type,
                                                         psychometricParameters,
                                                         setPsychometricParameters
                                                       }: Props) {

  function onAddRow() {
    setPsychometricParameters([...psychometricParameters, {}]);
  }

  function deleteParameter(parameter: PsychometricParameter) {
    setPsychometricParameters([...psychometricParameters.filter(param => param !== parameter)]);
  }

  function updateParameter(currentParam: PsychometricParameter, updatedParam: PsychometricParameter) {
    setPsychometricParameters([...psychometricParameters.filter(param => param !== currentParam), updatedParam]);
  }

  return (
      <PsychometricParameterTable psychometricParameterName={type} edit={true}>
        {psychometricParameters.map(parameter => (
            <TableRow key={parameter.id} sx={{
              '&:last-child td, &:last-child th': {border: 0},
              verticalAlign: "top"
            }}>
              <TableCell component="th" scope="row">
                <MarkdownPreviewWithEditDialog title="Psychometrischer Kennwert"
                                               value={parameter.parameter}
                                               onChange={value => updateParameter(parameter, {
                                                 ...parameter,
                                                 parameter: value
                                               })}/>
              </TableCell>
              <TableCell>
                <MarkdownPreviewWithEditDialog title="Vorgehen" value={parameter.approach}
                                               onChange={value => updateParameter(parameter, {
                                                 ...parameter,
                                                 approach: value
                                               })}/>
              </TableCell>
              <TableCell>
                <MarkdownPreviewWithEditDialog title="Ergebnisse" value={parameter.results}
                                               onChange={value => updateParameter(parameter, {
                                                 ...parameter,
                                                 results: value
                                               })}/>
              </TableCell>
              <TableCell>
                <MarkdownPreviewWithEditDialog title="Stichprobe" value={parameter.sample}
                                               onChange={value => updateParameter(parameter, {
                                                 ...parameter,
                                                 sample: value
                                               })}/>
              </TableCell>
              <TableCell align="right">
                <DeleteButton onClick={() => deleteParameter(parameter)}/>
              </TableCell>
            </TableRow>
        ))}
        <TableRow>
          <TableCell colSpan={5} align="right" sx={{border: "none"}}>
            <IconButton onClick={onAddRow}><AddCircleOutlineIcon/></IconButton>
          </TableCell>
        </TableRow>
      </PsychometricParameterTable>
  );
}